$(document).ready(function() {

  function changePage(hash) {
    if (hash !== undefined) {
      $('a[href="' + hash + '"]').tab('show');
    }
  }

  changePage(location.hash);

  $('a[data-toggle="tab"]').on('show.bs.tab', function(e) {
    location.hash = $(e.target).attr('href');
    setTimeout(function() {
      window.scrollTo(0, 0);
    }, 1);
  });

  $('#Companies_country').on('change', function() {
    changeRegData();
  });

  changeRegData();

  function changeRegData() {
    let type_jur = $('option:selected', $('#Companies_country')).data('jurisdiction');
    let type_j;

    if ('OTHER' == type_jur || 'USA' == type_jur) {
      type_j = 2;
    } else if ('EU' == type_jur) {
      type_j = 3;
    } else if ('RU' == type_jur) {
      type_j = 1;
    }

    $('.hidden').removeClass('hidden');
    $('.display_not_' + type_j).addClass('hidden');
    $('#companies_type_id').val(type_j);
  }

  function collectFields() {
    let getContract = true;

    let companyName = $('#Companies_companyName');
    let address = $('#Companies_address');
    let address_post = $('#Companies_address_post');
    let inn = $('#Companies_inn');
    let kpp = $('#Companies_kpp');
    let ogrn = $('#Companies_ogrn');
    let bik = $('#Companies_bik');
    let rschet = $('#Companies_rschet');
    let regNumber = $('#Companies_reg_number');
    let vat = $('#Companies_vat');

    let jurisdiction_value = $('#Companies_jurisdiction').val();

    let company_id = $('#Companies_id');

    if (!!companyName && !companyName.val().length) {
      getContract = false;

      if (!companyName.parents('.col-md-4').find('.alert').length) {
        companyName.parents('.col-md-4')
          .append('<div class="alert alert-danger margin-top-5 fade in">' + translate.company_empty_name + '</div>');
      }
    }

    if (address && !address.val().length) {
      getContract = false;

      if (!address.parents('.col-md-4').find('.alert').length) {
        address.parents('.col-md-4')
          .append('<div class="alert alert-danger fade in">' + translate.company_address + '</div>');
      }
    }


    if (address_post && !address_post.val().length) {
      getContract = false;

      if (!address_post.parents('.col-md-4').find('.alert').length) {
        address_post.parents('.col-md-4')
          .append('<div class="alert alert-danger fade in">' + translate.company_address_post + '</div>');
      }
    }

    let type_jur = $('option:selected', $('#Companies_country')).data('jurisdiction');
    if (typeof type_jur == 'undefined') {
      type_jur = $('#Companies_type_jur').val();
    }

    if (type_jur == 'RU') {
      if (!inn.val().length) {
        getContract = false;

        if (!inn.parents('.col-md-4').find('.alert').length) {
          inn.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_inn + '</div>');
        }
      }

      if (kpp && !kpp.val().length) {
        getContract = false;

        if (!kpp.parents('.col-md-4').find('.alert').length) {
          kpp.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_kpp + '</div>');
        }
      }

      if (ogrn && !ogrn.val().length) {
        getContract = false;

        if (!ogrn.parents('.col-md-4').find('.alert').length) {
          ogrn.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_ogrn + '</div>');
        }
      }

      if (bik && !bik.val().length) {
        getContract = false;

        if (!bik.parents('.col-md-4').find('.alert').length) {
          bik.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_bik + '</div>');
        }
      }

      if (rschet && !rschet.val().length) {
        getContract = false;

        if (!rschet.parents('.col-md-4').find('.alert').length) {
          rschet.parents('.col-md-4')
            .append('<div class="alert alert-danger fade in">' + translate.company_schet + '</div>');
        }
      }
    }

    if (!getContract) {
      return false;
    }

    return {
      YII_CSRF_TOKEN: token,
      type_jur: type_jur,
      companyName: companyName.val(),
      contractId: company_id.val(),
      company_id: company_id.val(),
      ogrn: ogrn.val(),
      vat: vat.val(),
      inn: inn.val(),
      kpp: kpp.val(),
      address: address.val(),
      address_post: address_post.val(),
      regNumber: regNumber.val(),
      jurisdiction: jurisdiction_value,
      bik: bik.val(),
      rschet: rschet.val(),
      nopics: $('#Companies_nopics').val()
    };
  }


  $('.download_contract').click(function(event) {
    event.preventDefault();

    let data = collectFields();

    if (false != data) {
      $('.activity-pace').css('display', 'inline-block');

      $.ajax({
        url: '/files/generateContractTemplate',
        type: 'POST',
        data: data
      })
        .done(function(response) {
          response = JSON.parse(response);
          if (response.code == 0) {
            $('.activity-pace').css('display', 'none');
            location.href = '/files/getFile/?id=' + parseInt(response.response);
          }
        })
        .fail(function(response) {
          $('.activity-pace').css('display', 'none');
        });
    }
  });

  $('body').on('click', '.company_get_addiction', function(event) {
    event.preventDefault();

    let data = collectFields();
    let that = $(this);

    if (false != data) {
      data.addition = 1;

      $.ajax({
        url: '/files/generateContractTemplate',
        type: 'POST',
        data: data
      })
        .done(function(response) {
          response = JSON.parse(response);
          if (response.code == 0) {
            documentStatusWidget('.' + that.attr('class'), [parseInt(response.response)]).done(function(file_ids) {
              location.href = '/files/getFile/?id=' + file_ids[0];
            });
          }
        });
    }
  });

});
